var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './SelectOption.styles.scss';
import { removeDiacriticsFromString } from '../../../Select.utils';
import { Checkbox } from '../../../../Checkbox';
export var SelectOption = function (_a) {
    var label = _a.label, descriptions = _a.descriptions, searchTerm = _a.searchTerm;
    var getTextWithSearchTerm = function (text) {
        if (!searchTerm) {
            return _jsx(_Fragment, { children: text });
        }
        var normalizedText = removeDiacriticsFromString(text).toLowerCase();
        var normalizedSearchTerm = removeDiacriticsFromString(searchTerm).toLowerCase();
        if (!!normalizedSearchTerm &&
            normalizedText.includes(normalizedSearchTerm)) {
            var startPos = normalizedText.indexOf(normalizedSearchTerm);
            return (_jsxs(_Fragment, { children: [text.substring(0, startPos), _jsx("strong", { children: text.substring(startPos, startPos + normalizedSearchTerm.length) }), text.substring(startPos + normalizedSearchTerm.length, startPos + text.length)] }));
        }
        else {
            return _jsx(_Fragment, { children: text });
        }
    };
    return (_jsxs("div", __assign({ className: "hefesto-select-option" }, { children: [_jsx("label", __assign({ className: "hefesto-select-option__label" }, { children: getTextWithSearchTerm(label) })), !!descriptions && descriptions.length > 0 && (_jsx("div", __assign({ className: "hefesto-select-option__descriptions" }, { children: descriptions.map(function (desc, idx) { return (_jsx("span", __assign({ className: "hefesto-select-option__descriptions--description" }, { children: getTextWithSearchTerm(desc) }), idx)); }) })))] })));
};
export var SelectCheckboxOption = function (_a) {
    var label = _a.label, value = _a.value, checked = _a.checked, descriptions = _a.descriptions, searchTerm = _a.searchTerm;
    return (_jsxs(_Fragment, { children: [_jsx(Checkbox, { name: "checked", checked: checked, value: value }), _jsx(SelectOption, { label: label, value: value, descriptions: descriptions, searchTerm: searchTerm })] }));
};
